export default "__VITE_ASSET__DZRh$wYp__"